import React from 'react';
import { Grid3X3, List } from 'lucide-react';
import { Toggle } from '../ui/toggle';

const ViewToggle = ({ isMosaicView, onToggle }) => {
  return (
    <Toggle
      pressed={isMosaicView}
      onPressedChange={onToggle}
      size="sm"
      className="data-[state=on]:bg-primary data-[state=on]:text-primary-foreground border-primary/20 [@media(hover:hover)_and_(pointer:fine)]:hover:shadow-md [@media(hover:hover)_and_(pointer:fine)]:hover:border-primary/40"
      aria-label={isMosaicView ? "Switch to List View" : "Switch to Mosaic View"}
    >
      {isMosaicView ? <List className="h-4 w-4" /> : <Grid3X3 className="h-4 w-4" />}
    </Toggle>
  );
};

export default ViewToggle;
